/** Api url */
const hoststart = window.location.host;
const host = (hoststart === 'local.pancan.org' || hoststart === 'staging.pancan.org' || hoststart === 'dev.pancan.org')? `${window.location.origin}` :'https://pancan.org';

const apiURL = `${host}/wp-json/wp/v2/posts/?`;
const manualAPIURL = `${host}/wp-json/wp/v2`;

/** Fetch api call */
export const fetchPosts = async(params_string : string) => await(fetch(apiURL + params_string).then(data => data.json()).then(data => data).catch(error => error));

/** Fetch api call Manual */
export const fetchManual = async(params_string: string) => await (fetch(`${manualAPIURL}${params_string}`, {mode: 'cors'}).then(data => data.json()).then(data => data).catch(error => {console.log('Error fetching Manual query posts', error); return false;}));
